import { Accordion, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";
// import DataTable from "datatables.net-bs5";
import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
// import Datepickers from '../../../components/Datepickers.js';
// import { get } from "sortablejs";
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import { useLocation } from "react-router-dom";
import LeaveViewModal from "./LeaveViewModal";

export default function LeavesListOfUser({leaves, leaveRefetch}) {

    const [leavesToDisplay, setLeavesToDisplay] = useState([]);
    const [search, setSearch] = useState("");
    const [text, setText] = useState({})
    const [selectedLeave, setSelectedLeave] = useState(null)
    const [leaveModalShow, setLeaveModalShow] = useState(false);


    const handleFilters = () => {
        setLeavesToDisplay(leaves.filter((item) => {
            if (search === "") return true;
            if (item.id.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item.reason.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.leaveType && item.leaveType.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.userId?.length > 0 && item.userId[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.status.toLowerCase().startsWith(search.toLowerCase())) {
                return true;
            } else if (item.reviewedBy?.length > 0 && item.reviewedBy[0].name.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (item.review.toLowerCase().includes(search.toLowerCase())) {
                return true;
            } else if (moment(item.startTime).format("DD/MM/YY hh:mm").includes(search.toLowerCase())) {
                return true;
            } else if (moment(item.endTime).format("DD/MM/YY hh:mm").includes(search.toLowerCase())) {
                return true;
            }
            return false;
        }))
    }

    useEffect(() => {
        handleFilters()
    }, [search, leaves])

    const updateLeaveStatusMutation = useMutation((data) => axios.put(`${DEV_SERVER}/leave/v2/updateLeaveStatus/${data.id}`, data.body, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                leaveRefetch()
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    let updateLeavesStatus = (id, status, review) => {
        updateLeaveStatusMutation.mutate({ id, body: { status, review } })
    }

    const columns = [
        {
            name: "Reason",
            color: true,
            selector: "reason",
            sortable: true,
            cell: (row) => <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.reason}</Tooltip>}>
                <span>{row?.reason}</span>
            </OverlayTrigger>
        },
        {
            name: "Leave Type",
            color: true,
            selector: "leaveType",
            sortable: true,
            cell: (row) => {
                if (row?.leaveType) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.leaveType}</Tooltip>}>
                        <span>{row?.leaveType}</span>
                    </OverlayTrigger>
                }
                return "NA"
            }
        },
        {
            name: "Start Date",
            sortable: true,
            color: true,
            selector: "startTime",
            cell: (row) => moment(row?.startTime * 1000).format("DD/MM/YY hh:mm a")
        },
        {
            name: "End Date",
            sortable: true,
            color: true,
            selector: "endTime",
            cell: (row) => moment(row?.endTime * 1000).format("DD/MM/YY hh:mm a")
        },
        {
            name: "Status",
            sortable: true,
            color: true,
            selector: (row) => <span style={{ color: row?.status === "pending" ? "red" : (row?.status === "approved" ? "green" : "orange") }}>{row?.status}</span>
        },
        {
            name: "Reviewed By",
            color: true,
            selector: (row) => {
                if (row?.reviewedBy?.length > 0) {
                    return row?.reviewedBy[0]?.name
                }
                return "NA"
            }
        },
        {
            name: "Review",
            color: true,
            selector: (row) => {
                if (row?.status === "pending") {
                    return <textarea style={{ width: "100%" }} value={text[row?.id] || ""} onChange={(e) => setText({ ...text, [row?.id]: e.target.value })} ></textarea>
                } else {
                    return row?.review === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.review}</Tooltip>}><span>{row?.review}</span></OverlayTrigger>
                }
            }
        },
        {
            name: "Action",
            color: true,
            selector: (row) => {
                return <span style={{ display: "flex", alignItems: "center", justifyContent: "center", columnGap: "0.8rem", opacity: row?.status === "pending" ? 1 : 0.5 }}>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Reject</Tooltip>}><i onClick={(e) => updateLeavesStatus(row?.id, "rejected", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "red" }} class="fas fa-times"></i></OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Approve</Tooltip>}><i onClick={(e) => updateLeavesStatus(row?.id, "approved", text[row?.id])} style={{ cursor: row?.status === "pending" ? "pointer" : "not-allowed", color: "green" }} class="fas fa-check"></i></OverlayTrigger>
                </span>
            }
        }

    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Leaves List</h4>
                                </div>
                                <div className="header-actions">
                                    <span style={{
                                        color: "green",
                                        fontWeight: "bold",
                                        fontSize: "16px",
                                        padding: "8px 16px",
                                        backgroundColor: "#f0f8ff",
                                        borderRadius: "6px",
                                        border: "2px solid #e6f3ff"
                                    }}>
                                        Leave Count: {leaves.filter(leave => leave.status === "approved").length}
                                    </span>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="mt-3" style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>
                                </div>
                                {<DataTable
                                    columns={columns}
                                    data={leavesToDisplay}
                                    pagination={true}
                                    paginationPerPage={35} // Set default rows per page to 35
                                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]} // Keep the options
                                    onRowClicked={(e) => {
                                        setSelectedLeave(e);
                                        setLeaveModalShow(true);
                                    }}
                                    customStyles={{
                                        rows: {
                                            style: {
                                                cursor: "pointer",
                                                backgroundColor: "unset",
                                            },
                                        },
                                    }}
                                />}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {leaveModalShow && <LeaveViewModal updateLeavesStatus={updateLeavesStatus} show={leaveModalShow} close={() => setLeaveModalShow(false)} leave={selectedLeave} />}
        </>
    )
}